
import { camelCase } from 'lodash';

export const getContentNameFromName = (name: string): string =>
	camelCase(name.replace(/\d{3}/g, '').replace(/-widget/, '')).replace(/Widget/, '').replace(/\w/, (m) => m.toUpperCase());
